const SMALL_WIDTH = 354;
const SMALL_HEIGHT = 193;
const LARGE_WIDTH = 708;
const LARGE_HEIGHT = 386;

const journalPages = {
  items: [
    {
      id: 0,
      title: 'journal-article--0--title',
      meta: {
        html_url: 'https://www.getmyboat.com/journal/experiences/bachelorette-party/20-unforgettable-bachelorette-boat-party-ideas-for-the-ultimate-celebration/',
        slug: '20-unforgettable-bachelorette-boat-party-ideas-for-the-ultimate-celebration',
        first_published_at: '2024-05-09T12:00:00.00Z',
        locale: 'en',
      },
      header_image: {
        sizes: [
          {
            url: 'https://cms-media.getmyboat.com/production/images/boat-rentals-austin-texas-premier-221-explorer.width-485.jpg',
            width: SMALL_WIDTH,
            height: SMALL_HEIGHT,
          },
          {
            url: 'https://cms-media.getmyboat.com/production/images/boat-rentals-austin-texas-premier-221-explorer.width-800.jpg',
            width: LARGE_WIDTH,
            height: LARGE_HEIGHT,
          },
        ],
      },
    },
    {
      id: 1,
      title: 'journal-article--1--title',
      meta: {
        html_url: 'https://www.getmyboat.com/journal/experiences/bachelorette-party/20-stunning-bachelorette-boat-party-decorations-to-elevate-your-celebration/',
        slug: '20-stunning-bachelorette-boat-party-decorations-to-elevate-your-celebration',
        first_published_at: '2024-04-01T12:00:00.00Z',
        locale: 'en',
      },
      header_image: {
        sizes: [
          {
            url: 'https://cms-media.getmyboat.com/production/images/bachelorette-boat-party-2-9674.width-557.jpg',
            width: SMALL_WIDTH,
            height: SMALL_HEIGHT,
          },
          {
            url: 'https://cms-media.getmyboat.com/production/images/bachelorette-boat-party-2-9674.width-918.jpg',
            width: LARGE_WIDTH,
            height: LARGE_HEIGHT,
          },
        ],
      },
    },
    {
      id: 2,
      title: 'journal-article--2--title',
      meta: {
        html_url: 'https://www.getmyboat.com/journal/experiences/bachelorette-party/20-chic-bachelorette-boat-party-outfit-ideas-for-a-memorable-celebration/',
        slug: '20-chic-bachelorette-boat-party-outfit-ideas-for-a-memorable-celebration',
        first_published_at: '2024-05-01T12:00:00.00Z',
        locale: 'en',
      },
      header_image: {
        sizes: [
          {
            url: 'https://cms-media.getmyboat.com/production/images/bachelorrete-party-boat-rentalwidth-1110-9248.width-337.jpg',
            width: SMALL_WIDTH,
            height: SMALL_HEIGHT,
          },
          {
            url: 'https://cms-media.getmyboat.com/production/images/bachelorrete-party-boat-rentalwidth-1110-9248.width-555.jpg',
            width: LARGE_WIDTH,
            height: LARGE_HEIGHT,
          },
        ],
      },
    },
    {
      id: 3,
      title: 'journal-article--3--title',
      meta: {
        html_url: 'https://www.getmyboat.com/journal/destinations/miami-bachelorette-boat-party-guide/',
        slug: 'miami-bachelorette-boat-party-guide',
        first_published_at: '2023-11-08T12:00:00.00Z',
        locale: 'en',
      },
      header_image: {
        sizes: [
          {
            url: 'https://cms-media.getmyboat.com/production/images/Miami_Bach.width-393.jpg',
            width: SMALL_WIDTH,
            height: SMALL_HEIGHT,
          },
          {
            url: 'https://cms-media.getmyboat.com/production/images/Miami_Bach.width-648.jpg',
            width: LARGE_WIDTH,
            height: LARGE_HEIGHT,
          },
        ],
      },
    },
    {
      id: 4,
      title: 'journal-article--4--title',
      meta: {
        html_url: 'https://www.getmyboat.com/journal/experiences/plan-the-perfect-boat-charter-bachelorette-party-with-getmyboat/',
        slug: 'plan-the-perfect-boat-charter-bachelorette-party-with-getmyboat',
        first_published_at: '2022-01-04T12:00:00.00Z',
        locale: 'en',
      },
      header_image: {
        sizes: [
          {
            url: 'https://cms-media.getmyboat.com/production/images/bachelorrete-party-boat-rentalwidth-1110-9248.width-337.jpg',
            width: SMALL_WIDTH,
            height: SMALL_HEIGHT,
          },
          {
            url: 'https://cms-media.getmyboat.com/production/images/bachelorrete-party-boat-rentalwidth-1110-9248.width-555.jpg',
            width: LARGE_WIDTH,
            height: LARGE_HEIGHT,
          },
        ],
      },
    },
    {
      id: 5,
      title: 'journal-article--5--title',
      meta: {
        html_url: 'https://www.getmyboat.com/journal/destinations/lake-travis-bachelorette-boat-party-guide-getmyboat/',
        slug: 'lake-travis-bachelorette-boat-party-guide-getmyboat',
        first_published_at: '2020-04-15T12:00:00.00Z',
        locale: 'en',
      },
      header_image: {
        sizes: [
          {
            url: 'https://cms-media.getmyboat.com/production/images/boat-rentals-austin-texas-premier-221-explorer.width-485.jpg',
            width: SMALL_WIDTH,
            height: SMALL_HEIGHT,
          },
          {
            url: 'https://cms-media.getmyboat.com/production/images/boat-rentals-austin-texas-premier-221-explorer.width-800.jpg',
            width: LARGE_WIDTH,
            height: LARGE_HEIGHT,
          },
        ],
      },
    },
  ],
};

export default journalPages;
